import { IElement, OneOfElements } from '@shared/models/project.model';
import {
  createElementPropertiesFromDataTable,
  getDataTableIdFromProperty,
} from '../../data-tables';
import { getElementProperties } from '../../element-property.helpers';
import { projectGuards } from '../../guards/project-guards.helpers';
import { ProjectChangeType } from '../update-engine.models';
import type { ProjectChangeMap } from '../update-engine.models';

type DataTableApplyChange =
  ProjectChangeMap[ProjectChangeType.ElementDataTablePropertiesApply];

/**
 * Replace properties linked to {@link DataTableApplyChange.dataTable} and append new ones from the table.
 */
export const elementDataTablePropertiesApplyToChange = (
  element: OneOfElements,
  change: DataTableApplyChange,
): Partial<IElement> | undefined => {
  if (!projectGuards.is.element(element)) return undefined;

  const dataTableProperties = createElementPropertiesFromDataTable(
    change.dataTable,
  );
  const elementProperties = getElementProperties(element).filter(
    (property) => getDataTableIdFromProperty(property) !== change.dataTable.id,
  );
  return {
    properties: [...elementProperties, ...dataTableProperties],
  };
};
